<template>
    <div class="container">
        <div class="vue-klantenvertellen-vestiging klantenvertellen-block-large row flex-column-reverse flex-md-row-reverse">
            <div class="content-wrapper dark-theme col-12 col-md-7 no-gutters">
                <div class="inner" v-if="hasRating">
                    <h2 v-html="ourCustomerRating"></h2>

                    <div class="rating-wrapper">
                        <div class="grade">
                            <a :href="viewLink" target="_blank">
                                {{ score }}
                            </a>
                        </div>

                        <div>
                            <div class="rating" :style="`--rating: ${percentage}`"></div>

                            <p>{{ basedOnText }}</p>
                        </div>

                        <a :href="writeLink" target="_blank" class="cta-link">{{ seeReviews }}</a>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-5">
                <div class="image-wrapper">
                    <div class="image"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {klantenvertellenOptions} from "../mixins/klantenvertellen";

export default {
    name: "ReviewBlockVestiging",

    mixins: [klantenvertellenOptions],

    data() {
        return {
            ourCustomerRating: window.Drupal.t(`<span class="color-main">Our customers</span><br> rate us with a`),
            seeReviews: window.Drupal.t('Also write a review')
        }
    },

    methods: {
        shouldPopulateCookie() {
            return false;
        }
    }
}
</script>
